module.exports = __webpack_public_path__ + "img/xybs01.57ba61f5.png";